
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'query',
    'kind',
    'preview',
    'previewName',
    'previewMeta',
    'previewMother',
    'previewUnderAge',
    'previewUnavailable',
    'submitButton'
  ]

  connect() {
    this.format()
    this.setSubmitEnabled(false)
    this.preview()
  }

  disconnect() {
    clearTimeout(this.previewTimeout)
    this.previewRequest?.abort()
  }

  format() {
    if (this.kindTarget.value === 'cpf') {
      this.formatCpf()
    } else if (this.kindTarget.value === 'phone_number') {
      this.formatPhoneNumber()
    }
  }

  preview() {
    const digits = this.queryTarget.value.replace(/\D/g, '')

    clearTimeout(this.previewTimeout)
    this.previewRequest?.abort()
    this.hidePreviewFeedback()
    this.setSubmitEnabled(false)

    if (digits.length !== 11) return

    this.previewTimeout = setTimeout(() => this.fetchPreview(digits), 300)
  }

  async fetchPreview(cpf) {
    const request = new AbortController()
    this.previewRequest = request

    try {
      const response = await fetch(`/anonymous_searches/preview?cpf=${cpf}`, { signal: request.signal })
      if (!response.ok) throw new Error('Preview request failed')

      const data = await response.json()
      if (this.currentCpf() !== cpf || this.previewRequest !== request) return

      this.renderPreview(data)
    } catch (error) {
      if (error.name === 'AbortError' || this.currentCpf() !== cpf) return

      this.showPreviewUnavailable()
    } finally {
      if (this.previewRequest === request) this.previewRequest = null
    }
  }

  renderPreview(data) {
    this.hidePreviewFeedback()

    if (data.censored) {
      if (this.hasPreviewUnderAgeTarget) this.previewUnderAgeTarget.classList.remove('hidden')
      this.setSubmitEnabled(false)
      return
    }

    if (data.found !== true) {
      this.showPreviewUnavailable()
      return
    }

    this.setSubmitEnabled(true)
    if (!this.hasPreviewTarget) return

    this.previewNameTarget.textContent = data.name || ''

    const metaParts = []
    if (data.age) metaParts.push(`${data.age} anos`)
    if (data.gender === 'male') metaParts.push('Masculino')
    else if (data.gender === 'female') metaParts.push('Feminino')
    this.previewMetaTarget.textContent = metaParts.join(' · ')

    if (this.hasPreviewMotherTarget) {
      this.previewMotherTarget.textContent = data.mother_name || ''
    }

    this.previewTarget.classList.remove('hidden')
  }

  showPreviewUnavailable() {
    this.hidePreviewFeedback()
    if (this.hasPreviewUnavailableTarget) this.previewUnavailableTarget.classList.remove('hidden')
    this.setSubmitEnabled(false)
  }

  hidePreviewFeedback() {
    if (this.hasPreviewTarget) this.previewTarget.classList.add('hidden')
    if (this.hasPreviewUnderAgeTarget) this.previewUnderAgeTarget.classList.add('hidden')
    if (this.hasPreviewUnavailableTarget) this.previewUnavailableTarget.classList.add('hidden')
  }

  setSubmitEnabled(enabled) {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = !enabled
  }

  currentCpf() {
    return this.queryTarget.value.replace(/\D/g, '')
  }

  formatCpf() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    this.queryTarget.value = value
  }

  formatPhoneNumber() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{2})(\d)/, "($1) $2")
    value = value.replace(/(\d{4,5})(\d{4})$/, "$1-$2")
    this.queryTarget.value = value
  }
}
